import { FC, useState } from 'react';

import { Select } from 'antd';
import dayjs from 'dayjs';
import { Button, Label, Table } from 'ui';

import { EventDatesType } from 'types/events/eventTypes';

import s from './EventOfferShowRestriction.module.scss';

interface EventOfferShowRestrictionTypeProps {
  shows?: EventDatesType[];
  showRestrictions?: string[];
  setShowRestrictions?: (showRestrictions: string[] | undefined) => void;
}

const EventOfferShowRestriction: FC<EventOfferShowRestrictionTypeProps> = ({
  showRestrictions,
  shows,
  setShowRestrictions,
}) => {
  const [errors, setErrors] = useState<boolean>();
  const [dateItem, setDateItem] = useState<string>();

  const handleAddOrUpdate = () => {
    if (!dateItem) {
      setErrors(true);
      return; // Ensure it's not undefined
    }

    const prev = showRestrictions ?? [];

    const exists = prev.findIndex((item) => item === dateItem);

    const newEntry: string = dateItem;

    const updated: string[] =
      exists !== -1
        ? prev.map((item, idx) => (idx === exists ? newEntry : item))
        : [...prev, newEntry];

    setShowRestrictions!(updated);
  };

  const handleDelete = (item: string) => {
    const filtered = showRestrictions?.filter((i) => item.toLowerCase() !== i);
    setShowRestrictions!(filtered);
  };

  const columns = [
    {
      title: 'Show Date',
      dataIndex: 'startDate',
      key: 'startDate',
      render: (date: string) => dayjs(date).format('DD MMM YYYY'),
    },

    {
      title: 'Show Time',
      dataIndex: 'startTime',
      key: 'startTime',
    },

    {
      title: 'Action',
      key: 'action',
      render: (row) => (
        <div className={s.actionButtons}>
          <button type="button" onClick={() => handleDelete(row.showId)}>
            Delete
          </button>
        </div>
      ),
    },
  ].filter(Boolean) as any;

  return (
    <div className={s.wrapper}>
      <div className={s.labelWrapper}>
        <Label>
          If you include any date/s here the offer will be limited ONLY to the show date/s chosen.{' '}
        </Label>
      </div>

      <div className={s.content}>
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'column',
            justifyContent: 'center',
          }}>
          <div style={{ width: '100%', marginBottom: 20 }}>
            <Label required>Show</Label>
            <Select
              className={`${s.ticketSelect} ${errors ? s.error : ''}`}
              options={shows?.map((item) => ({
                label: item.startDate,
                value: item.showId?.toLowerCase(),
              }))}
              placeholder="Select shows"
              value={dateItem}
              onChange={(value) => {
                setDateItem(value);
              }}
            />
          </div>

          <Button
            disabled={showRestrictions?.includes(dateItem ?? '')}
            htmlType="button"
            fullWidth
            onClick={handleAddOrUpdate}>
            Add
          </Button>
        </div>

        <div>
          {!!showRestrictions?.length && (
            <Table
              dataSource={shows?.filter((item) =>
                showRestrictions?.some((r) => r === item.showId?.toLowerCase()),
              )}
              rowKey="showId"
              columns={columns}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default EventOfferShowRestriction;
